import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [autenticado, setAutenticado] = useState(null);

  const verificarAutenticacao = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/index.php?rota=validarCookie`, {
        credentials: "include",
      });
      const data = await res.json();
      setAutenticado(data.sucesso);
    } catch {
      setAutenticado(false);
    }
  };

  useEffect(() => {
    verificarAutenticacao();
  }, []);

  return (
    <AuthContext.Provider value={{ autenticado, verificarAutenticacao }}>
      {children}
    </AuthContext.Provider>
  );
};